import {
  mapMutations,
} from 'vuex';

export default {
  name: 'PersonalDataTitle',
  components: {},
  props: {
    personalDataTitle: '',
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  data: () => ({
    errorState: false,
  }),
  computed: {},
  methods: {
    ...mapMutations('appointment', {
      setPersonalDataMutation: 'SET_PERSONALDATA',
    }),
    setTitle(title) {
      this.errorState = false;

      const changePersonalDataStateObject = {
        state: title,
        property: 'title',
      };

      this.setPersonalDataMutation(changePersonalDataStateObject);
    },
    isValid() {
      this.errorState = this.personalDataTitle === '';
      return !this.errorState;
    },
  },
};
